<div
  class="way-purchase-layout way-purchase-selection-layout"
  *ngIf="isVisible && displayVm"
>
  <p class="way-purchase-layout__subtitle" *ngIf="displayVm.subtitle">{{ displayVm.subtitle }}</p>

  <div class="way-purchase-selection-layout__cards">
    <app-way-purchase-selection-card
      *ngFor="let card of displayVm.cards; trackBy: trackByCardId"
      [card]="card"
      [cardPlateInputs]="cardPlateInputs"
      [plateInputDisabled]="plateInputDisabled"
      [cardError]="cardErrorFor(card)"
      [isBusy]="isBusy"
      [isCardBusy]="isCardBusy(card)"
      (use)="onUse(card)"
      (cancel)="onCancel(card)"
      (plateInputChange)="onCardPlateInput(card.id, $event)"
    />
  </div>
</div>
